import AbstractProfessionModel from './AbstractProfessionModel';

export default class ProfessionModel extends AbstractProfessionModel {}
